/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';
import { UpdateDistributorDto } from '../../models/update-distributor-dto';

export interface UpdateOneBaseMgmtDistributorControllerCompany$Params {
  id: number;
      body: UpdateDistributorDto
}

export function updateOneBaseMgmtDistributorControllerCompany(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtDistributorControllerCompany.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Company>;
    })
  );
}

updateOneBaseMgmtDistributorControllerCompany.PATH = '/api/mgmt/distributors/{id}';
